import React from 'react'

import { FaHeart, FaBars } from 'react-icons/fa'
//import reactLogo from "./assets/logo.svg"

import axios from 'axios'
import urldata from '../../../urldata'
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom'

import CareerList from '../Views/CareerList'
import SalesList from '../Views/SalesList'
import PurchaseList from '../Views/PurchaseList'
import HomepageBannerList from '../Views/HomepageBannerList'
import JobPostlist from '../Views/Jobpostlist'
import JobApplication from '../Views/JobApplication'
import ReviewerList from '../Views/ReviewerList'
import FeedbackCenterList from '../Views/FeedbackCenterList'
import GetInTochList from '../Views/GetInTochList'

const Main = ({
	collapsed,
	rtl,
	image,
	handleToggleSidebar,
	handleCollapsedChange,
	handleRtlChange,
	handleImageChange,
	history,
}) => {
	const logoutBtnClick = (id) => {
		let url = new URL(urldata + 'admin/logout')

		axios({
			method: 'post',
			url: url,
			withCredentials: true,
		})
			.then((response) => {
				localStorage.clear()
				history.push('/admin')
			})
			.catch((error) => {
				localStorage.clear()
				history.push('/admin')
			})
	}
	return (
		<main>
			<div className='btn-toggle' onClick={() => handleToggleSidebar(true)}>
				<FaBars />
			</div>
			<header className='d-f jc-sb a-c'>
				<p>Dashboard</p>
				<div
					className='logout_btn c-p'
					onClick={() => {
						logoutBtnClick()
					}}
				>
					Logout
				</div>
			</header>

			<>
				<div className='dashboardDataContainer'>
					<Switch>
						<Route
							exact
							path='/admin/dashboard/JobApplicationList'
							//path='/admin/dashboard/Jobpostlist'
							component={JobApplication}
						/>

						<Route
							exact
							//path='/admin/dashboard/hompeagebannerlist'
							path='/admin/dashboard'
							component={HomepageBannerList}
						/>

						<Route
							exact
							//path='/admin/dashboard/hompeagebannerlist'
							path='/admin/dashboard/ReviewerList'
							component={ReviewerList}
						/>

						<Route
							exact
							//path='/admin/dashboard/hompeagebannerlist'
							path='/admin/dashboard/feedbackList'
							component={FeedbackCenterList}
						/>

						<Route
							exact
							//path='/admin/dashboard/hompeagebannerlist'
							path='/admin/dashboard/getInTouchList'
							component={GetInTochList}
						/>

						<Route
							exact
							//path='/admin/dashboard/career'
							path='/admin/dashboard/Jobpostlist'
							component={JobPostlist}
						/>

						<Route
							exact
							path='/admin/dashboard/banner'
							component={CareerList}
						/>
						<Route exact path='/admin/dashboard/sales' component={SalesList} />
						<Route
							exact
							path='/admin/dashboard/purchase'
							component={PurchaseList}
						/>
						<Redirect to='/admin/dashboard' />
					</Switch>
				</div>
			</>

			<footer></footer>
		</main>
	)
}

export default Main
